export default __webpack_public_path__ + "static/media/SteamBridge.37d2a534.jpg";